import { MdErrorOutline } from "react-icons/md";
import { useEdittingStore } from "../context/useEdittingStore";
import styles from "../page.module.css";
import SelectorPill from "./selector-pill";
import { TypeEnum } from "@/types/types";

export default function SelectorsWrapper({ t }: { t: any }) {
  const type = useEdittingStore((state) => state.listing.type);
  const number_of_rooms = useEdittingStore(
    (state) => state.listing.number_of_rooms
  );
  const numberOfRoomsError = useEdittingStore(
    (state) => state.validationErrors.number_of_rooms
  );
  const number_of_full_bathrooms = useEdittingStore(
    (state) => state.listing.number_of_full_bathrooms
  );
  const numberOfFullBathroomsError = useEdittingStore(
    (state) => state.validationErrors.number_of_full_bathrooms
  );
  const number_of_bathrooms = useEdittingStore(
    (state) => state.listing.number_of_bathrooms
  );
  const numberOfBathroomsError = useEdittingStore(
    (state) => state.validationErrors.number_of_bathrooms
  );
  const number_of_bedrooms = useEdittingStore(
    (state) => state.listing.number_of_bedrooms
  );
  const numberOfBedroomsError = useEdittingStore(
    (state) => state.validationErrors.number_of_bedrooms
  );
  const setField = useEdittingStore((state) => state.setField);
  return (
    <>
      {(type === TypeEnum.APARTMENT || type === TypeEnum.HOUSE) && (
        <div className={styles.selectorsWrapper}>
          <div className={styles.selectorRow}>
            <SelectorPill
              value={`${number_of_rooms}`}
              onSelect={(newValue: number) => {
                setField("number_of_rooms", newValue);
              }}
              hasError={numberOfRoomsError ? true : false}
            >
              <h3
                id="number_of_rooms"
                className={`${styles.fieldTitle} ${
                  numberOfRoomsError && styles.error
                }`}
              >
                {t("numberOfRooms")}*
                {numberOfRoomsError && (
                  <span className={styles.errorText}>
                    {t(numberOfRoomsError)}
                    <span>
                      <MdErrorOutline />
                    </span>
                  </span>
                )}
              </h3>
            </SelectorPill>
            <SelectorPill
              value={`${number_of_full_bathrooms}`}
              onSelect={(newValue: number) => {
                setField("number_of_full_bathrooms", newValue);
              }}
              hasError={numberOfFullBathroomsError ? true : false}
            >
              <h3
                id="number_of_full_bathrooms"
                className={`${styles.fieldTitle} ${
                  numberOfFullBathroomsError && styles.error
                }`}
              >
                {t("numberOfFull")} {t("bathrooms")}*
                {numberOfFullBathroomsError && (
                  <span className={styles.errorText}>
                    {t(numberOfFullBathroomsError)}
                    <span>
                      <MdErrorOutline />
                    </span>
                  </span>
                )}
              </h3>
            </SelectorPill>
          </div>
          <div className={styles.selectorRow}>
            <SelectorPill
              value={`${number_of_bathrooms}`}
              onSelect={(newValue: number) => {
                setField("number_of_bathrooms", newValue);
              }}
              hasError={numberOfBathroomsError ? true : false}
            >
              <h3
                id="number_of_bathrooms"
                className={`${styles.fieldTitle} ${
                  numberOfBathroomsError && styles.error
                }`}
              >
                {t("numberOf")} {t("bathrooms")}*
                {numberOfBathroomsError && (
                  <span className={styles.errorText}>
                    {t(numberOfBathroomsError)}
                    <span>
                      <MdErrorOutline />
                    </span>
                  </span>
                )}
              </h3>
            </SelectorPill>
            <SelectorPill
              value={`${number_of_bedrooms}`}
              onSelect={(newValue: number) => {
                setField("number_of_bedrooms", newValue);
              }}
              hasError={numberOfBedroomsError ? true : false}
            >
              <h3
                id="number_of_bedrooms"
                className={`${styles.fieldTitle} ${
                  numberOfBedroomsError && styles.error
                }`}
              >
                {t("numberOf")} {t("bedrooms")}*
                {numberOfBedroomsError && (
                  <span className={styles.errorText}>
                    {t(numberOfBedroomsError)}
                    <span>
                      <MdErrorOutline />
                    </span>
                  </span>
                )}
              </h3>
            </SelectorPill>
          </div>
        </div>
      )}
    </>
  );
}
